// Embrace's site code
export const SITE_CODE: string = '831lunyc4q';

// Flags
export const QE_NB_1603_PAGE_4_CARE_CREDIT: string = 'qe-ab-1603_page_4_care_credit';
export const QE_AB_143_ACCIDENT_ONLY_TEST: string = 'qe-ab-143_accident_only_test';
export const AB_153_PAGE_ONE_ENHANCED_CONTENT = 'qe-ab-153_page_1_content_enhancements';

// Page Load Goals
export const QE_SELECT_A_POLICY_ACCESSED_GOAL = 327486;
export const QE_CONTACT_INFORMATION_ACCESSED_GOAL = 327487;
export const QE_CONGRATULATIONS_ACCESSED_GOAL = 327489;

// Button Click Goals
export const QE_PET_INFORMATION_SUBMIT_GOAL = 324986;
export const QE_SELECT_A_POLICY_CONTENT_SUBMIT_GOAL = 327491;
export const QE_SELECT_A_POLICY_LOCKING_BAR_SUBMIT_GOAL = 327493;
export const QE_SELECT_A_POLICY_ALL_SUBMITS_GOAL = 347595;
export const QE_CONTACT_SUBMIT_PURCHASE_GOAL = 324989;

// Custom Data
export const CUSTOM_DATA_BRAND_ID = 9;
export const CUSTOM_DATA_NUMBER_OF_PETS_ID = 10;
export const CUSTOM_DATA_RATING_STATE_ID = 11;
export const CUSTOM_DATA_UTM_CAMPAIGN = 14;
export const CUSTOM_DATA_UTM_SOURCE = 15;
export const CUSTOM_DATA_UTM_MEDIUM = 16;
export const CUSTOM_DATA_UTM_CONTENT = 17;
export const CUSTOM_DATA_UTM_TERM = 18;
export const CUSTOM_DATA_QUOTE_TYPE = 19;
export const CUSTOM_DATA_QUOTE_ID = 20;
export const CUSTOM_DATA_SUPPLEMENTAL_TYPE = 21;

// Variation ON
export const VARIATION_ON = 'on';
export const VARIATION_OFF = 'off';
export const VARIATION_NOT_TARGETED = 'not_targeted';

